import { usePermissionCheck } from "@hex-insights/permissioning";
import { Redirect } from "@hex-insights/router";
import { permissions } from "@s-i-s-i/see-learning.shared";
import { homePageInfo } from "../../Home/pageinfo";

export type PermissionedRedirectToHomeProps = {
	model: keyof typeof permissions;
};

export function PermissionedRedirectToHome({ model }: PermissionedRedirectToHomeProps) {
	const hasPermission = usePermissionCheck({ requiredPermission: permissions[model].View.Admin });

	if (!hasPermission) {
		return <Redirect to={homePageInfo.to} />;
	}
	return null;
}
